import { z } from "zod";
import {
  PromotionCodeSchema,
  StripeCheckoutSessionStatusSchema,
  StripeSubscriptionStatusSchema,
} from "../../models/stripe.schema";

export const StripeControllerResponseSchema = {
  getSession: z.object({
    status: StripeCheckoutSessionStatusSchema.nullable(),
    customerStripeEmail: z.string(),
    customerStripeId: z.string(),
    subscriptionStripeId: z.string(),
  }),

  createProductPrice: z.object({
    prices: z
      .object({
        title: z.string(),
        description: z.string(),
        price: z.number(),
        productId: z.string(),
        interval: z.enum(["day", "week", "month", "year"]),
      })
      .array(),
  }),

  createSession: z.object({
    clientSecret: z.string().nullable(),
  }),

  getCustomersByEmail: z.object({
    stripeId: z.string(),
    email: z.string().email().nullable(),
    subscriptions: z
      .object({
        id: z.string(),
        status: StripeSubscriptionStatusSchema,
      })
      .array(),
    metadata: z.record(z.string()),
  }),

  getCoupon: PromotionCodeSchema.optional(),
};
